import { useEffect } from "react";
import { useContext } from "react";
import { createContext, useState } from "react";
import { getCartCollaboration } from "../api/collaborationApi";
import { UserContext } from "./userContext";


export const CartContext = createContext();

export default function CartProvider({ children }) {

    const [shoppingCartCount, setShoppingCartCount] = useState(0);
    const [cart, setCart] = useState([]);
    const { userType, userToken } = useContext(UserContext);
    const [cartTotal, setCartTotal] = useState(0);

    const [discountCode, setDiscountCode] = useState('');
    const [cuponApply, setCuponApply] = useState(false);

    useEffect(() => {

        if (userType === 'company') {
            getCartCollaboration({ token: userToken }).then((response) => {
                setShoppingCartCount(response.length)
                setCart(response)
                let suma = 0
                for (let i = 0; i < response.length; i++) {
                    suma += response[i].totalPrice
                }

                setCartTotal(suma);
            })
        }

    }, [userToken])

    return (
        <CartContext.Provider value={{ shoppingCartCount, setShoppingCartCount, cart, setCart, cartTotal, setCartTotal, discountCode, setDiscountCode, cuponApply, setCuponApply }}>
            {children}
        </CartContext.Provider >
    )

};